import { type AnyRoute } from '@tanstack/react-router';

import {
  type RouteExport,
  type RouteExportParams,
} from '~/types/router.type.ts';

/**
 * Builds a route export object from the provided parameters.
 * This helper function ensures type safety when creating route exports.
 *
 * @param params - Route export parameters including the Route instance
 * @returns A complete RouteExport object
 */
export function buildRouteExport(
  params: RouteExportParams & { Route: AnyRoute },
): RouteExport {
  return params;
}
